import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import React from 'react';
const SegmentedPickerButton = ({
  onClick,
  className: _className = '',
  isDisabled,
  width,
  value,
  children
}) => {
  const handleClick = event => onClick(value, event.target.value);
  return /*#__PURE__*/React.createElement(Button, {
    className: _className,
    onClick: handleClick,
    disabled: isDisabled,
    style: {
      width: `${width}%`
    }
  }, children);
};
SegmentedPickerButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  width: PropTypes.number.isRequired
};
export default SegmentedPickerButton;